const patternConstant = {
  ALPHANUMERIC: /^[a-zA-Z0-9- ]+$/,
  NUMERIC: /^[0-9]+$/,
  FLOATNUMERIC: /^\d+(\.\d{0,2})?$/,
  PERCENTAGE: /^(\d{0,2})(\.\d{0,2})?$/,
  ///^\d{0,2}+(\.\d{0,2})?$/
};

export const emailSignaturOptions = [
  "Use the user email signature",
  "Use this signature",
  "Use the system default signature",
  "No signature",
];

export const emailTemplateFields = [
  {
    id: "template_name",
    label: "Template Name",
    placeHolder: "Enter template name",
    type: "text",
    isRequired: true,
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
  
  {
    id: "signature_option",
    label: "Signature",
    placeHolder: "select",
    type: "select",
    options: [
      {
        label: "Use the user email signature",
        id: "user_email_signature",
      },
      { label: "Use custom signature", id: "custom_signature" },
      {
        label: "Use the system default signature",
        id: "system_default_signature",
      },
      { label: "No signature", id: "no_signature" },
    ],
    isRequired: true,
  },
{
    id: "lead_stage",
    label: "Lead Stage",
    placeHolder: "select",
    type: "select",
    options: [
      {
        label: "Lead Created",
        id: "LEAD",
      },
      { label: "Estimate", id: "ESTIMATE" },
      {
        label: "Survey",
        id: "SURVEY",
      },
      { label: "Quote", id: "QUOTE" },
      { label: "Job Confirmed", id: "CONFIRMED" },
      { label: "Provisional", id: "PROVISIONAL" },
      { label: "Job Completed", id: "COMPLETED" },
      { label: "General / Marketing", id: "GENERAL_MARKETING" },
    ],
    isRequired: true,
  },
  {
    id:'is_primary',
    label:'Is Default Template ?',
    type:'checkbox',
    firstColmd: 5,
    md: 7,
  },
  {
    id: "default_sender_email",
    label: "Default Sender Email",
    placeHolder: "select",
    type: "select",
    options: [],
  },
  {
    id: "signature",
    label: "Signature",
    placeHolder: "Enter signature",
    type: "editor",
    minRows: 2,
    // isRequired: true,
    autocomplete: "off",
    firstColmd: 2.5,
    md: 9.5,
  },
 
  {
    id: "subject",
    label: "Subject",
    placeHolder: "Enter subject",
    type: "editor",
    isRequired: true,
    minRows: 2,
    // isRequired: true,
    autocomplete: "off",
    firstColmd: 2.5,
    md: 9.5,
  },
  {
    id: "disclaimer",
    label: "Disclaimer",
    placeHolder: "Enter disclaimer",
    type: "editor",
    minRows: 3,
    isRequired: true,
    patternAllowed: patternConstant?.ALPHANUMERIC,
    firstColmd: 2.5,
    md: 9.5,
  },
 
  {
    id: "body",
    label: "Body",
    placeHolder: "Enter body",
    type: "editor",
    minRows: 4,
    isRequired: true,
    patternAllowed: patternConstant?.ALPHANUMERIC,
    firstColmd: 2.5,
    md: 9.5,
  },
];

export const SEND_EMAIL_TEMPLATE_FIELDS = [
  {
    id: "to",
    label: "Recipient Email",
    placeHolder: "Enter recipient email",
    type: "autocomplete",
    isRequired: true,
    options: [],
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
  {
    id: "subject",
    label: "Subject",
    placeHolder: "select",
    type: "text",
    isRequired: true,
  },
  {
    id: "cc",
    label: "CC",
    placeHolder: "Enter CC email",
    type: "chipText",
    isRequired: true,
    firstColmd: 2.5,
    md: 9.5,
  },

  {
    id: "bcc",
    label: "BCC",
    placeHolder: "Enter BCC email",
    type: "chipText",
    isRequired: true,
     firstColmd: 2.5,
    md: 9.5,
  },

  // {
  //   id: "signature",
  //   label: "Signature",
  //   placeHolder: "Enter signature",
  //   type: "editor",
  //   minRows: 2,
  //   // isRequired: true,
  //   autocomplete: "off",
  //   firstColmd: 2.5,
  //   md: 9.5,
  // },

  {
    id: "body",
    label: "Body",
    placeHolder: "Enter body",
    type: "editor",
    minRows: 4,
    isRequired: true,
    patternAllowed: patternConstant?.ALPHANUMERIC,
    firstColmd: 2.5,
    md: 9.5,
  },
];

export const emailTagFields = [
  {
    label: "{{date}}",
  },
  {
    label: "{{username}}",
  },
  {
    label: "{{today}}",
  },
  {
    label: "{{useremail}}",
  },
  {
    label: "{{usermobile}}",
  },
  {
    label: "{{ref}}",
  },
  {
    label: "{{addrline}}",
  },
  {
    label: "{{toaddrline}}",
  },
  {
    label: "{{email}}",
  },
  {
    label: "{{password}}",
  },
];
